<template>
  <a :href="model.TargetUrl" class="widget">
    <div class="widget__title">{{ $res.Views.HomePage_Widget_AwaitingConfirmation }}</div>
    <div class="widget__body">
      <div class="widget__count" 
           :class="{ 'widget__count_small': model.Count > 99 }">
        {{ model.Count }}
      </div>
      <div class="widget__content">
        <div class="widget__content-inner">
          {{ $tc("bookingTextOnly", model.Count)}}
        </div>
        <div class="widget__icon">
          <svg width="36" height="36" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8.4001 4.49998C8.4001 4.00292 7.99715 3.59998 7.5001 3.59998C7.00304 3.59998 6.6001 4.00292 6.6001 4.49998V8.99998C6.6001 9.49703 7.00304 9.89998 7.5001 9.89998H10.0001C10.4972 9.89998 10.9001 9.49703 10.9001 8.99998C10.9001 8.50292 10.4972 8.09998 10.0001 8.09998H8.4001V4.49998Z" fill="currentColor"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M8.0001 0.0999756C3.63705 0.0999756 0.100098 3.63693 0.100098 7.99998C0.100098 12.363 3.63705 15.9 8.0001 15.9C12.3631 15.9 15.9001 12.363 15.9001 7.99998C15.9001 3.63693 12.3631 0.0999756 8.0001 0.0999756ZM8.0001 1.89998C4.63116 1.89998 1.9001 4.63104 1.9001 7.99998C1.9001 11.3689 4.63116 14.1 8.0001 14.1C11.369 14.1 14.1001 11.3689 14.1001 7.99998C14.1001 4.63104 11.369 1.89998 8.0001 1.89998Z" fill="currentColor"/>
          </svg>
        </div>
      </div>
    </div>
  </a>
</template>

<script>
export default {
  props: {
    model: Object,
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
@use "./widget";

.widget__content {
  margin-top: 4px;
}
</style>


